<!-- 首页 -->
<template>
  <div @scroll="windowScroll">
    <Header :scrollTop="scrollTop" :cIdx="0" />
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide>
        <img
          loading="lazy"
          v-lazy="require('@/assets/home/banner-1.jpg')"
          width="100%"
          alt=""
        />
      </swiper-slide>

      <swiper-slide>
        <img
          loading="lazy"
          v-lazy="require('@/assets/home/banner-3.jpg')"
          width="100%"
          alt=""
        />
      </swiper-slide>
      <swiper-slide>
        <img
          loading="lazy"
          v-lazy="require('@/assets/home/banner-2.jpg')"
          width="100%"
          alt=""
        />
      </swiper-slide>

      <!-- 轮播点 -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!--  -->
      <!-- 如果需要导航按钮 -->
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
    <div class="title_box">
      <div class="title">
        <span class="title_tx1"> Product</span
        ><span class="title_tx2 ml10">service</span>
      </div>
      <div class="title_tx"><h1>产品服务</h1></div>
      <div class="tilte_line"></div>
    </div>
    <div class="service_box">
      <div class="s_item p80" @click="toEquipment">
        <img
          class="s_item_img s_img1"
          loading="lazy"
          v-lazy="require('@/assets/home/s_img1.png')"
        />
      </div>
      <div class="s_item" @click="toEquipment">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img1.png')"
        />
      </div>
      <div class="s_item" @click="toEquipment">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img2.png')"
        />
      </div>
      <div class="s_item" @click="toEquipment">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img3.png')"
        />
      </div>
      <div class="s_item" @click="toEquipment">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img4.png')"
        />
      </div>
      <div class="s_item p80" @click="toDetection">
        <img
          class="s_item_img s_img2"
          loading="lazy"
          v-lazy="require('@/assets/home/s_img2.png')"
        />
      </div>
      <div class="s_item" @click="toDetection">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img5.png')"
        />
      </div>
      <div class="s_item" @click="toDetection">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img6.png')"
        />
      </div>
      <div class="s_item" @click="toDetection">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img7.png')"
        />
      </div>
      <div class="s_item" @click="toDetection">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img8.png')"
        />
      </div>
      <div class="s_item p80" @click="toSystem">
        <img
          class="s_item_img s_img3"
          loading="lazy"
          v-lazy="require('@/assets/home/s_img3.png')"
        />
      </div>
      <div class="s_item" @click="toSystem">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img9.png')"
        />
      </div>
      <div class="s_item" @click="toSystem">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img10.png')"
        />
      </div>
      <div class="s_item" @click="toSystem">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img11.png')"
        />
      </div>
      <div class="s_item" @click="toSystem">
        <img
          class="s_item_img"
          loading="lazy"
          v-lazy="require('@/assets/home/s_item_img12.png')"
        />
      </div>
    </div>

    <div class="title_box">
      <div class="title">
        <span class="title_tx1"> Professional </span
        ><span class="title_tx2 ml10">advantage</span>
      </div>
      <div class="title_tx"><h1>专业优势</h1></div>
      <div class="tilte_line"></div>
    </div>

    <div class="advantage_box">
      <div class="a_item">
        <img
          class="a_item_img transitionImg"
          loading="lazy"
          v-lazy="require('@/assets/home/a_img1.png')"
        />
        <div class="a_item_tx_box">
          <div class="a_tx_tilte">定制研发技术实力</div>
          <div class="a_tx_content">
            百人专业技术团队，来自于北京理工大学、浙江大学等知名高校，高度集成对接融合多平台，满足客户复杂业务场景需求，合作全流程多对一服务为您保驾护航
          </div>
        </div>
      </div>

      <div class="a_item">
        <div class="a_item_tx_box1">
          <div class="a_tx_tilte">20余年集成客户服务经验</div>
          <div class="a_tx_content">
            1000+项目应用案例，20年行业认可口碑，100%客户满意回购率，积累了深厚的虹膜识别算法基础研究和项目技术战略规划经验
          </div>
        </div>
        <img
          class="a_item_img transitionImg"
          loading="lazy"
          v-lazy="require('@/assets/home/a_img2.png')"
        />
      </div>

      <div class="a_item">
        <img
          class="a_item_img transitionImg"
          loading="lazy"
          v-lazy="require('@/assets/home/a_img3.png')"
        />
        <div class="a_item_tx_box">
          <div class="a_tx_tilte">国家级别权威认证</div>
          <div class="a_tx_content">
            高新技术企业，专精特新企业，小巨人企业，参与《生物特征识别技术与标准化》(2023)的编制，已取得知识产权80余项
          </div>
        </div>
      </div>

      <div class="a_item">
        <div class="a_item_tx_box1">
          <div class="a_tx_tilte">源头技术生产厂家</div>
          <div class="a_tx_content">
            2003年取得第一个虹膜专利，20年不断钻研创新，核心技术全部自研，在北京、西安、深圳等地均设有分支机构，生产基地2000平
          </div>
        </div>
        <img
          class="a_item_img transitionImg"
          loading="lazy"
          v-lazy="require('@/assets/home/a_img4.png')"
        />
      </div>
    </div>
    <div class="sy_box" @click="toAbout">
      <div class="title_box">
        <div class="title">
          <span class="title_tx1"> Sy </span><span class="title_tx2">kean</span>
        </div>
        <div class="title_tx"><h1>思源科安</h1></div>
        <div class="tilte_line"></div>
      </div>
      <div class="flex">
        <div class="sx_tx">
          苏州思源科安信息技术有限公司是一家专注于虹膜识别技术的国家级高新技术企业。公司以自有的虹膜识别算法和专利技术为基础，研发和生产多种身份认证设备。这些设备广泛用于多个行业，如矿山、公安、金融、建筑、医疗和教育，公司在虹膜识别方面拥有丰富的技术储备和经验积累，服务人数已超千万。
        </div>
        <img
          class="sy_img"
          loading="lazy"
          v-lazy="require('@/assets/home/sy_img.png')"
        />
      </div>
      <div class="timeaxis">
        <div class="box1 li">
          <div class="line"></div>
        </div>
        <div
          class="boxs li"
          v-for="(item, idx) in timeData"
          :key="idx"
          @mouseover="handleMouseOver(idx)"
          @mouseout="handleMouseOut()"
        >
          <div class="line"></div>
          <div class="circular" :class="cIdex == idx ? 'active' : ''"></div>
          <div class="d_line"></div>
          <div class="txDate" :class="cIdex == idx ? 'activeTX' : ''">
            {{ item.txDate }}
          </div>
          <div class="desc" :class="cIdex == idx ? 'activeTX' : ''">
            {{ item.txDesc }}
          </div>
        </div>

        <div class="box1 li">
          <div class="line"></div>
          <div class="right_arrow"></div>
        </div>
      </div>
    </div>

    <div class="title_box">
      <div class="title">
        <span class="title_tx1"> Company </span
        ><span class="title_tx2 ml10">strength</span>
      </div>
      <div class="title_tx"><h1>我们的实力</h1></div>
      <div class="tilte_line"></div>
    </div>
    <div class="strength_box" @click="toAbout">
      <img
        class="strength_img transitionImg"
        loading="lazy"
        v-lazy="require('@/assets/home/strength_img1.jpg')"
      />
      <img
        class="strength_img mt80 mb40 transitionImg"
        loading="lazy"
        v-lazy="require('@/assets/home/strength_img2.png')"
      />
    </div>

    <div class="title_box">
      <div class="title">
        <span class="title_tx1"> News </span
        ><span class="title_tx2 ml10">center</span>
      </div>
      <div class="title_tx"><h1>新闻中心</h1></div>
      <div class="tilte_line"></div>
    </div>

    <div class="new_box" @click="toNews">
      <div class="new_row">
        <img
          class="row_img transitionImg"
          loading="lazy"
          v-lazy="require('@/assets/home/news_img1.jpg')"
        />
        <div class="row_tx ml80">
          作为致力于推动矿山信息化发展的科技企业，思源科安本次受邀参会，为与会者们带去了精心打造的融合了最新科技的智慧矿山虹膜识别身份认证产品和安全管理解决方案。众所周知，移动化和远程化，一直是近年来生物识别技术发展的大趋势，对此思源科安的研发脚步一直未有停歇。
        </div>
      </div>

      <div class="new_row mt80">
        <div class="row_tx">
          苏州思源科安在此次会议中展示的虹膜识别仪C100、虹膜采集仪SY308、桌面式多维生物特征采集一体机LS500都是以虹膜识别为核心技术的系列产品，他们具有唯一性、高稳定性、高防伪性和生物活性等特点，可应用于多个不同领域。作为以多模态生物识别技术和万级数据库信息为基础，以多模态生物识别平台为支撑，以生物识别技术为核心的自主研发型公司。
        </div>
        <img
          class="row_img ml40 transitionImg"
          loading="lazy"
          v-lazy="require('@/assets/home/news_img2.png')"
        />
      </div>
    </div>

    <div class="about_us_box mb80">
      <div class="title_box">
        <div class="title">
          <span class="title_tx1"> Contact </span
          ><span class="title_tx2 ml10">us</span>
        </div>
        <div class="title_tx"><h1>联系我们</h1></div>
        <div class="tilte_line"></div>
      </div>
      <div class="about_us_tx">
        专业的产品介绍 &nbsp;&nbsp;&nbsp;&nbsp; 尊享多对一服务
      </div>
      <div class="phone_box transitionImg">
        <img
          class="phone_icon"
          loading="lazy"
          v-lazy="require('@/assets/home/aboutUs_img.png')"
        />
        <div class="phone_num"><a href="tel:15801031606">15801031606</a></div>
      </div>
    </div>

    <Footer />
    <RightBar />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import RightBar from "@/components/RightBar.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import "../assets/common.scss";

export default {
  name: "homePage",
  components: { Header, Footer, RightBar, Swiper, SwiperSlide },
  data() {
    return {
      swiperOptions: {
        //swiper配置信息
        //分页器
        pagination: {
          el: ".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        loop: false,
        autoplay: {
          delay: 5000, // 幻灯片停留时间
          stopOnLastSlide: false, // 用户操作swiper之后，是否禁止autoplay
          disableOnInteraction: false, // 如果设置为true，当切换到最后一个slide时停止自动切换。（loop模式下无效）。
        },
        on: {
          slideChangeTransitionEnd: function () {
            console.log(this.activeIndex); //切换结束时，告诉我现在是第几个slide
          },
        },
      },
      hover: false,
      timeData: [
        {
          txDate: "2003年",
          txDesc: "创始团队研发出虹膜识别核心算法",
        },
        {
          txDate: "2004年",
          txDesc: "开发了国内首套嵌入式虹膜识别设备",
        },
        {
          txDate: "2008年",
          txDesc: "在北京成立思源科安信息技术有限公司",
        },
        {
          txDate: "2012年",
          txDesc: "组建思源西安团队",
        },
        {
          txDate: "2015年",
          txDesc: "成立苏州思源科安信息技术有限公司,获得第一笔融资",
        },
        {
          txDate: "2018年",
          txDesc: "技术研发团队超过100人",
        },
        {
          txDate: "2020年",
          txDesc: "2月疫情爆发期给北京小汤山医院提供身份识别设备",
        },
        {
          txDate: "2023年",
          txDesc: "核心专利突破66项",
        },
        {
          txDate: "2024年",
          txDesc: "新增生产基地",
        },
      ],
      scrollTop: 0,
      cIdex: null,
    };
  },

  methods: {
    handleMouseOver(idx) {
      this.cIdex = idx;
    },
    handleMouseOut() {
      this.cIdex = null;
    },

    to(index) {
      this.swiper.slideTo(index - 1);
    },

    toEquipment() {
      this.$router.push({ path: "/equipment" });
    },

    toDetection() {
      this.$router.push({ path: "/detection" });
    },

    toSystem() {
      this.$router.push({ path: "/system" });
    },

    toNews() {
      this.$router.push({ path: "/news" });
    },

    toAbout() {
      this.$router.push({ path: "/about" });
    },

    windowScroll() {
      this.scrollTop = document.documentElement.scrollTop;
    },
  },

  mounted() {
    // 添加事件监听
    window.addEventListener("scroll", this.windowScroll);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener("scroll", this.windowScroll);
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .service_box {
    border-top: 2px solid #70b4ff;
    border-left: 2px solid #70b4ff;
    width: 1520px;
    margin: 30px auto;
    display: flex;
    flex-wrap: wrap;
    .s_item {
      display: flex;
      border-bottom: 2px solid #70b4ff;
      border-right: 2px solid #70b4ff;
      padding: 60px;
      width: 303px;
      height: 397px;
      // width: 1520px;
      overflow: hidden;
      .s_item_img {
        margin: 30px auto;
        transition: transform 0.3s ease; /* 定义过渡动画 */
        max-width: 100%; /* 限制图片最大宽度 */
      }
      .s_img1 {
        margin: auto;
        width: 150px;
        height: 98px;
      }
      .s_img2 {
        margin: auto;
        width: 125px;
        height: 95px;
      }
      .s_img3 {
        margin: auto;
        width: 122px;
        height: 150px;
      }

      .s_item_img:hover {
        transform: scale(1.2); /* 鼠标悬浮时放大1.2倍 */
      }
    }
  }
  .boxs {
    overflow: hidden;
    float: left;
    position: relative;
    // width: 180px;
    flex: 1;
    height: 750px;
  }

  .desc {
    width: 180px !important;
    height: 320px;
    position: absolute;
    bottom: 0;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: 400;
    line-height: 32.4px;
    color: #666666;
  }
}
@media screen and (min-width: 1200px) {
  .service_box {
    border-top: 2px solid #70b4ff;
    border-left: 2px solid #70b4ff;
    width: 1520px;
    margin: 30px auto;
    display: flex;
    flex-wrap: wrap;
    .s_item {
      display: flex;
      border-bottom: 2px solid #70b4ff;
      border-right: 2px solid #70b4ff;
      width: 303px;
      height: 397px;
      overflow: hidden;
      .s_item_img {
        margin: auto;
        transition: transform 0.3s ease; /* 定义过渡动画 */
        max-width: 100%; /* 限制图片最大宽度 */
      }
      .s_item_img:hover {
        transform: scale(1.1); /* 鼠标悬浮时放大1.1倍 */
      }
    }
  }
}

.advantage_box {
  display: flex;
  flex-direction: column;
  .a_item {
    display: flex;
    height: 380px;
    margin: 40px 270px;
    .a_item_img {
      width: 380px;
      height: 380px;
    }
    .a_item_tx_box {
      margin: auto 20px auto 80px;
    }
    .a_item_tx_box1 {
      margin: auto 80px auto 0px;
    }
    .a_tx_tilte {
      font-family: PingFang SC;
      font-size: 62px;
      font-weight: 500;
      line-height: 86.8px;
      color: #333333;
    }
    .a_tx_content {
      font-family: PingFang SC;
      font-size: 34px;
      font-weight: 400;
      line-height: 47.6px;
      text-align: left;
      color: #333333;
    }
  }
}
.sy_box {
  width: 100%;
  // height: 1892px;
  background-image: url("@/assets/home/sy_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 40px;
  .sx_tx {
    height: 530px;
    width: 5540px;
    font-family: PingFang SC;
    font-size: 34px;
    font-weight: 400;
    // line-height: 47.6px;
    text-align: left;
    color: #333;
    margin-left: 220px;
  }
  .sy_img {
    width: 870px;
    height: 530px;
    margin-left: 60px;
    margin-right: 220px;
  }
  .timeaxis {
    display: flex;
    overflow: hidden;
    margin-top: 100px;
    width: 100%;
    height: 100%;
    padding: 40px 110px;
    justify-content: center;

    .box1 {
      width: 60px;
      float: left;
      height: 680px;
      position: relative;
    }

    .boxs {
      overflow: hidden;
      float: left;
      position: relative;
      // width: 180px;
      flex: 1;
      height: 680px;
    }

    .d_line {
      height: 28px;
      width: 2px;
      background: #008fd7;
    }
    .boxs:nth-child(odd) .d_line {
      text-align: center;
      position: absolute;
      top: 38.2%;
      left: 49%;
    }

    .boxs:nth-child(even) .d_line {
      text-align: center;
      position: absolute;
      top: 49%;
      left: 49%;
    }

    .txDate {
      width: 156px;
      font-family: PingFang SC;
      font-size: 40px;
      font-weight: 500;
      line-height: 56px;
      text-align: left;
      color: #333333;
    }

    .boxs:nth-child(odd) .txDate {
      text-align: center;
      position: absolute;
      top: 28%;
    }

    .boxs:nth-child(even) .txDate {
      text-align: center;
      position: absolute;
      bottom: 34%;
    }

    .line {
      border-bottom: 10px solid #d9d9d9;
      position: absolute;
      width: 100%;
      top: 46%;
      transform: translateY(-50%);
      left: 0;
    }

    .circular {
      font-size: 14px;
      text-align: center;
      z-index: 10;
      color: #1890ff;
      width: 26px;
      line-height: 26px;
      height: 26px;
      border-radius: 50px;
      background: white;
      margin: auto;
      position: absolute;
      top: 46%;
      transform: translate(-50%, -50%);
      left: 50%;
      border: 3px solid #008fd7;
    }

    .desc {
      width: 156px;
      height: 220px;
      position: absolute;
      bottom: 0;
      font-family: PingFang SC;
      font-size: 22px;
      font-weight: 400;
      line-height: 36.4px;
      color: #666666;
    }

    .boxs:nth-child(odd) .desc {
      text-align: center;
      position: absolute;
      top: 4px;
      width: 100%;
    }

    .boxs:nth-child(even) .desc {
      text-align: center;
      position: absolute;
    }

    .active {
      background: #1890ff;
      color: #fff;
    }
    .activeTX {
      font-weight: bolder;
      color: #1890ff;
    }

    .show {
      display: flex !important;
    }
  }
}
.strength_box {
  display: flex;
  flex-direction: column;
  width: 1520px;
  justify-content: center;
  margin: 10px auto 50px auto;
  .strength_img {
    width: 1520px;
  }
}

.about_us_box {
  width: 100%;
  height: 946px;
  background-image: url("@/assets/aboutUs_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 946px;
  padding-top: 40px;
  .about_us_tx {
    width: 100%;
    height: 70px;
    font-family: PingFang SC;
    font-size: 50px;
    font-weight: 500;
    line-height: 70px;
    text-align: center;
    color: #081020;
    justify-content: center;
  }
  .phone_box {
    display: flex;
    width: 700px;
    height: 170px;
    line-height: 170px;
    border: 4px solid #008fd7;
    justify-content: center;
    margin: 60px auto;
    .phone_icon {
      width: 90px;
      height: 90px;
      margin: auto 20px auto 30px;
    }
    .phone_num {
      font-family: PingFang SC;
      font-size: 60px;
      font-weight: 500;
      text-align: center;
      color: #081020;
    }
  }
}
.right_arrow {
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-left-color: #1890ff;
  position: absolute;
  right: -30px;
  top: 46%;
  transform: translateY(-50%);
}
</style>
